export default __webpack_public_path__ + "static/media/twitter.6bd413cc.png";